jQuery($ => {
  class MapBlock {
    constructor(element) {
      this._ = element;
      this._element = $(element);
      this._map = this._element.find('.o-map-block__map');
      this._markers = this._element.find('.o-map-block__marker');

      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
      this._element.trigger('init', this);

    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      async function initMap(mapBlock) {
        const { Map, InfoWindow } = await google.maps.importLibrary("maps");
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
        let $markers = $(mapBlock).find('.o-map-block__marker');
        let zoom = $markers.length > 1 ? parseInt(GOOGLEMAPS.multipleLocationZoom) : parseInt(GOOGLEMAPS.singleLocationZoom);

        const markersArr = [];
        const map = new Map(mapBlock, {
          center: { lat: 0, lng: 0 },
          mapId: "locations-map",
          mapTypeControl: false,
          streetViewControl: false,
          zoomControl: true
        });

        const infoWindow = new google.maps.InfoWindow({
          content: '',
          disableAutoPan: true,
        })

        $($markers).each(function (index, $marker) {
          const lat = parseFloat($marker.getAttribute("data-lat"));
          const lng = parseFloat($marker.getAttribute("data-lng"));

          markersArr.push({ lat: lat, lng: lng, title: $marker.getAttribute("data-title"), address: $marker.getAttribute("data-address") });
        });

        const bounds = new google.maps.LatLngBounds();

        markersArr.map((position, i) => {
          const marker = new google.maps.marker.AdvancedMarkerElement({
            map: map,
            position: { lat: position.lat, lng: position.lng },
          });

          marker.addListener('click', () => {
            infoWindow.setContent('<div class="o-map-block__info-window"><h3 class="u-h4">' + position.title + '</h3><p>' + position.address + '</p></div>');
            infoWindow.open(map, marker);
          });
          bounds.extend(marker.position);
        });

        if (markersArr.length === 1) {
          map.setCenter(bounds.getCenter());
          map.setZoom(zoom);
        } else {
          map.fitBounds(bounds);

          google.maps.event.addListenerOnce(map, "bounds_changed", () => {
            map.setZoom(zoom);
          });
        }
      }


      $(this._map).each(function (index, $mapBlock) {
        initMap($mapBlock);
      });
    }
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.map_block = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].map_block = new MapBlock(_[i], opt);
      else
        ret = _[i].map_block[opt].apply(_[i].map_block, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.o-map-block').map_block();
});